import { useCallback, useEffect, useState } from "react";
import { Languages, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const NAMES = { de: "German", fr: "French", es: "Spanish" };

const Panel = ({ lang }) => {
  const [s, setS] = useState(null);
  const load = useCallback(() => api.get(`/admin/i18n/${lang}/status`).then((r) => setS(r.data)).catch(() => setS(null)), [lang]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (!s?.running) return undefined;
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [s?.running, load]);

  const run = async () => {
    try { await api.post(`/admin/i18n/${lang}/translate`); toast.success(`Translating new ${NAMES[lang]} text…`); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };

  if (!s) return null;
  return (
    <div data-testid={`admin-translations-panel-${lang}`} className="flex flex-wrap items-center justify-between gap-4 rounded-3xl border border-slate-200 bg-white p-5 sm:p-6">
      <div className="flex items-center gap-4">
        <span className="flex h-11 w-11 items-center justify-center rounded-full bg-violet-100 text-violet-700"><Languages className="h-5 w-5" /></span>
        <div>
          <p className="font-display text-lg text-slate-900">{NAMES[lang]} website (/{lang})</p>
          <p className="text-[13px] text-slate-500" data-testid={`admin-translations-status-${lang}`}>
            {s.translated} texts translated · {s.pending} new texts waiting{s.running ? " · translating now…" : ""}
          </p>
        </div>
      </div>
      <button type="button" onClick={run} disabled={s.running || s.pending === 0} data-testid={`admin-translate-button-${lang}`}
        className="inline-flex h-11 items-center gap-2 rounded-full bg-[#0B0716] px-5 text-sm font-semibold text-white transition-colors hover:bg-violet-700 disabled:cursor-not-allowed disabled:opacity-40">
        {s.running && <Loader2 className="h-4 w-4 animate-spin" />} Translate new text
      </button>
    </div>
  );
};

export const TranslationsPanel = () => (
  <div className="mt-10 grid gap-4" data-testid="admin-translations-panel">
    {Object.keys(NAMES).map((l) => <Panel key={l} lang={l} />)}
  </div>
);
